goog.provide('el8.appchart.dialog.ordermed.selectPharmacy');

goog.require('el8.template.appchart.dialog.ordermed.selectPharmacy');
goog.require('el8.ptdata.base');
goog.require('el8.ptdata.model.ptPreferences');
goog.require('el8.service.urls');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.template.mindreader');

el8.appchart.dialog.ordermed.selectPharmacy = (function() {
    var selectedPharmacy = null;
    var saveCallbackFn = null;
    var printCallbackFn = null;
    var hideCallbackFn = null;
    var includePreferred = true;
    var controlledMeds = false;

    var that = new el8.uiwidget.FormDialog({
        title: 'Select Pharmacy for ePrescribing',
        autoHeight: true,
        modal: true,
        width: 400,
        contentFn: el8.template.appchart.dialog.ordermed.selectPharmacy.content
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'pharmacy',
                selector: ':input[name="pharmacy"]',
                infoText: 'select pharmacy to send ePrescription',
                maxLength: 100,
                newMindreader: true,
                mindreaderOpts: {
                    containerWidth: 400,
                    url: function() {
                        var type = controlledMeds ? 'controlled_substance' : 'newrx';
                        return el8.service.urls.get('searchPharmacies', [type, includePreferred]);
                    },
                    showOnFocus: true,
                    minQueryLength: 0,
                    selectFn: function(e, item) {
                        selectedPharmacy = el8.data.pharmacies.create(item);
                        populateAddress();
                    },
                    formatResult: function(item) {
                        return el8.template.mindreader.pharmacy({item: item});
                    },
                    formatSelected: function(item) {
                        return item.store_name;
                    },
                    emptyQueryText: 'Displaying preferred pharmacies. Enter more information to choose a different pharmacy.'
                }
            }
        ]
    });
    form.addButton('save', 'Select Pharmacy', function(_form) {
        if (isValidPharmacy()) { //Mindreader item or previously selected pharmacy
            that.hide();
            if (saveCallbackFn) {
                saveCallbackFn(selectedPharmacy);
            }
        } else {
            clearInvalidPharmacy(); //Anything else should throw an error
        }
    }, true);
    form.addButton('print', 'Print Only', function(_form) {
        that.hide();
        if (printCallbackFn) {
            printCallbackFn(selectedPharmacy);
        }
    });
    form.addCancelButton(function() {
        that.hide();
    });
    that.setForm(form);
    
    var super_show = that.show;
    that.show = function(opts) {
        opts = opts || {};
        selectedPharmacy = null;
        super_show.call(that);
        
        saveCallbackFn = opts.saveCallbackFn || null;
        printCallbackFn = opts.printCallbackFn || null;
        hideCallbackFn = opts.hideCallbackFn || null;
        includePreferred = (opts.includePreferred !== false); //default true
        if (opts.pharmacyNcpdpid) {
            selectedPharmacy = el8.data.pharmacies.getByKey(opts.pharmacyNcpdpid);
            form.setVal('pharmacy', selectedPharmacy.getStoreName());
        }

        controlledMeds = (opts.controlledMeds === true); // default false

        populateAddress();
        
        //hidePrintButton is useful when setting a pharmacy preference, rather than making an order
        if (opts.hidePrintButton) {
            form.hideButton('print');
        } else {
            form.showButton('print');
        }
    };
    
    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        if (hideCallbackFn) { hideCallbackFn(); }
    };
    
    var populateAddress = function() {
        if (!selectedPharmacy) {
            $('.pharmacy-address-div', form.getContainer()).html('');
        } else {
            $('.pharmacy-address-div', form.getContainer()).html(
                el8.template.appchart.dialog.ordermed.selectPharmacy.pharmacyAddress(
                    selectedPharmacy.asSoyMap()
                )
            );
        }
        that.adjustHeight();
    };
    
    /* The user can select from the returned results or leave the previous result (which would not a mindreader item) behind
     */
    var isValidPharmacy = function() {
        return ( form.getMindreaderItem('pharmacy') ||
                 (selectedPharmacy && selectedPharmacy.getStoreName() === form.getVal('pharmacy')) );
    };
    
    var clearInvalidPharmacy = function() {
        el8.uiwidget.alert('Please select an existing pharmacy, or hit "cancel".');
        form.setVal('pharmacy', '');
        selectedPharmacy = null;
        populateAddress();    
    };
    
    return that;

})();